export default "__VITE_ASSET__0933758a__"